import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const getPermissionAndRoleAction = createAsyncThunk(
    'my-permissions',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/my-permissions`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getPermissionAndRoleSlice = createSlice({
    name: 'my-permissions',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getPermissionAndRoleAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getPermissionAndRoleAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getPermissionAndRoleAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getPermissionAndRoleReducer = getPermissionAndRoleSlice.reducer
